<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
export default {
  name: "app",
  data: function () {
    return {
      currentRoute: this.$route.name,
    };
  },
  watch: {
    $route: function (to, from) {
      if (localStorage.hasOwnProperty("reviewUserData")) {
        let userData = JSON.parse(localStorage.getItem("reviewUserData"));
        Vue.http.headers.common["TOKEN"] = userData.data.token;
        // if (userData.userRegister && Vue.http.interceptors.length < 8) {
        if (userData.userRegister && Vue.http.interceptors.length < 8) {
          Vue.http.interceptors.push(function (request, next) {
            next(function (response) {
              if (response.status == 403) {
                localStorage.clear();
                window.location = "#/";
              }
            });
          });
        }
        if (to.name == "Login") {
          let sb = JSON.parse(localStorage.vocSidebar);
          localStorage.menuIndex = 0;
          window.location = "#" + sb[0].url;

        }
      } else {
        if (to.fullPath === "/register") {
          return;
        }
        if (to.fullPath.includes("/invite")) {
          return;
        }
        if (this.$route.path == "/create-demo") {
          window.location = "#/create-demo";
        } else {
          window.location = "#/";
        }
      }
    },
  },
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "assets/css/responsive.css";
</style>
